const searchList= {
  0:{
    title:'进程',
    action:[
      {
        id:'',
        val:'执行动作'
      },
      {
        id:1,
        val:'拦截'
      },
      {
        id:2,
        val:'放行'
      }, 
      {
        id:3,
        val:'未处理'
      }, 
    ],
    operation:[
      {
        id:'',
        val:'操作类型'
      },
      {
        id:'',
        val:'操作类型'
      }
    ],
    serchTxt:[
      {
        placeholder:'模糊搜索进程'
      },
      {
        placeholder:'模糊搜索文件名称'
      }
    ],
    columns: [
        {
            title: '执行动作',
            key: 'action',
            width:'120px'
        },
        {
            title: '进程ID',
            key: 'pid',
            width:'120px'
        },
        {
            title: '进程路径',
            key: 'fullPath',
            width:'300px'
        },
        {
          title: '父进程ID',
          key: 'parentPid',
          width:'120px'
        },
        {
          title: '创建时间',
          key: 'createTime',
        }
    ],
  },
  1:{
    title:'文件',
    action:[
      {
        id:'',
        val:'执行动作'
      },
      {
        id:1,
        val:'拦截'
      },
      {
        id:2,
        val:'放行'
      }, 
      {
        id:3,
        val:'未处理'
      }, 
    ],
    operation:[
      {
        id:'',
        val:'操作类型'
      },
      {
        id:1,
        val:'写入'
      },
      {
        id:2,
        val:'删除'
      },
      {
        id:3,
        val:'删重命名除'
      }
    ],
    serchTxt:[
      {
        placeholder:'模糊搜索进程'
      },
      {
        placeholder:'模糊搜索文件名称'
      }
    ],
    columns:[
      {
        title: '执行动作',
        key: 'action',
        tree: true,
        width:'70px'
      },
      {
        title: '进程ID',
        key: 'action',
        tree: true,
        width:'110px'
      },
      {
        title: '进程路径',
        key: 'action',
        tree: true,
        width:'300px'
      },
      {
        title: '操作类型',
        key: 'action',
        tree: true,
        width:'110px'
      },
      {
        title: '文件路径',
        key: 'action',
        tree: true
      },
    ]
  },
  2:{
    title:'模块',
    action:[
      {
        id:'',
        val:'执行动作'
      },
      {
        id:1,
        val:'拦截'
      },
      {
        id:2,
        val:'放行'
      }, 
      {
        id:3,
        val:'未处理'
      }, 
    ],
    operation:[],
    serchTxt:[
      {
        placeholder:'模糊搜索进程'
      },
      {
        placeholder:'模糊搜索模块名称及各类特征'
      }
    ],
    columns:[
      {
        title: '执行动作',
        key: 'action',
        tree: true,
        width:'70px'
      },
      {
        title: '进程ID',
        key: 'action',
        tree: true,
        width:'110px'
      },
      {
        title: '进程路径',
        key: 'action',
        tree: true,
        width:'300px'
      },
      {
        title: '模块路径',
        key: 'action',
        tree: true,
        width:'300px'
      },
      {
        title: '模块MD5',
        key: 'action',
        tree: true,
        width:'110px'
      },
      {
        title: '模块特征码',
        key: 'action',
        tree: true,
        width:'110px'
      },
      {
        title: '数字签名公司名',
        key: 'action',
        tree: true,
        width:'110px'
      },
      {
        title: '数字签名序列号',
        key: 'action',
        tree: true
      },
    ]
  },
  3:{
    title:'驱动',
    action:[
      {
        id:'',
        val:'执行动作'
      },
      {
        id:1,
        val:'拦截'
      },
      {
        id:2,
        val:'放行'
      }, 
      {
        id:3,
        val:'未处理'
      }, 
    ],
    operation:[],
    serchTxt:[
      {
        placeholder:'模糊搜索模块名称及各类特征'
      }
    ],
    columns:[
      {
        title: '执行动作',
        key: 'action',
        tree: true,
        width:'70px',
        resizable: true,
      },
      {
        title: '加载顺序',
        key: 'action',
        tree: true
      },
      {
        title: '驱动文件路径',
        key: 'action',
        tree: true
      },
      {
        title: '驱动MD5',
        key: 'action',
        tree: true
      },
      {
        title: '驱动特征码',
        key: 'action',
        tree: true
      },
      {
        title: '数字签名公司名',
        key: 'action',
        tree: true
      },
      {
        title: '数字签名序列号',
        key: 'action',
        tree: true
      },
    ]
  },
  4:{
    title:'窗口',
    action:[
      {
        id:'',
        val:'执行动作'
      },
      {
        id:1,
        val:'拦截'
      },
      {
        id:2,
        val:'放行'
      }, 
      {
        id:3,
        val:'未处理'
      }, 
    ],
    operation:[],
    serchTxt:[]
  },
  5:{
    title:'线程',
    action:[
      {
        id:'',
        val:'执行动作'
      },
      {
        id:1,
        val:'拦截'
      },
      {
        id:2,
        val:'放行'
      }, 
      {
        id:3,
        val:'未处理'
      }, 
    ],
    operation:[],
    serchTxt:[]
  },
  6:{
    title:'网络',
    action:[
      {
        id:'',
        val:'执行动作'
      },
      {
        id:1,
        val:'拦截'
      },
      {
        id:2,
        val:'放行'
      }, 
      {
        id:3,
        val:'未处理'
      }, 
    ],
    operation:[],
    serchTxt:[
      {
        placeholder:'模糊搜索进程'
      },
      {
        placeholder:'模糊搜索IP、域名'
      }
    ],
    columns:[
      {
        title: '执行动作',
        key: 'action',
        tree: true,
        width:'70px'
      },
      {
        title: '进程ID',
        key: 'action',
        tree: true
      },
      {
        title: '进程路径',
        key: 'action',
        tree: true
      },
      {
        title: '协议',
        key: 'action',
        tree: true
      },
      {
        title: '通信方式',
        key: 'action',
        tree: true
      },
      {
        title: '通信方向',
        key: 'action',
        tree: true
      },
      {
        title: '关联域名',
        key: 'action',
        tree: true
      },
    ]
  },
  7:{
    title:'HTTP',
    action:[
      {
        id:'',
        val:'执行动作'
      },
      {
        id:1,
        val:'拦截'
      },
      {
        id:2,
        val:'放行'
      }, 
      {
        id:3,
        val:'未处理'
      }, 
    ],
    operation:[],
    serchTxt:[
      {
        placeholder:'模糊搜索进程'
      },
      {
        placeholder:'模糊搜索IP、域名'
      }
    ],
    columns:[
      {
        title: '执行动作',
        key: 'action',
        tree: true,
        width:'70px'
      },
      {
        title: '进程ID',
        key: 'action',
        tree: true
      },
      {
        title: '进程路径',
        key: 'action',
        tree: true
      },
      {
        title: '协议',
        key: 'action',
        tree: true
      },
      {
        title: '通信方式',
        key: 'action',
        tree: true
      },
      {
        title: '通信方向',
        key: 'action',
        tree: true
      },
      {
        title: '关联域名',
        key: 'action',
        tree: true
      },
    ]
  },
  8:{
    title:'Dns',
    action:[
      {
        id:'',
        val:'执行动作'
      },
      {
        id:1,
        val:'拦截'
      },
      {
        id:2,
        val:'放行'
      }, 
      {
        id:3,
        val:'未处理'
      }, 
    ],
    operation:[],
    serchTxt:[
      {
        placeholder:'模糊搜索进程'
      },
      {
        placeholder:'模糊搜索IP、域名'
      }
    ],
    columns:[
      {
        title: '执行动作',
        key: 'action',
        tree: true,
        width:'70px'
      },
      {
        title: '进程ID',
        key: 'action',
        tree: true
      },
      {
        title: '进程路径',
        key: 'action',
        tree: true
      },
      {
        title: '协议',
        key: 'action',
        tree: true
      },
      {
        title: '通信方式',
        key: 'action',
        tree: true
      },
      {
        title: '通信方向',
        key: 'action',
        tree: true
      },
      {
        title: '关联域名',
        key: 'action',
        tree: true
      },
    ]
  }
  
}


class logBasic{
  constructor() {}
  getSearch(val){
    return searchList[val]
  }
}

export default new logBasic()